<template>
 <div class="cont" >
  <div style="padding:20px;height:360px; overflow-x: auto;" v-if="tableList.length>0">

    <!-- <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"
          style="width: 100%" center border :span-method="objectSpanMethod">
      <el-table-column prop="months" label="日期" align="center" width="200"></el-table-column>
       <el-table-column property="sName" min-width="120"  :show-overflow-tooltip="true" label="排放"></el-table-column>
      <el-table-column property="vNo" min-width="120" :formatter="emptyFn"   :show-overflow-tooltip="true" label="车次"></el-table-column>
      <el-table-column prop="tWeight"  min-width="120" :formatter="emptyFn"  :show-overflow-tooltip="true" label="吨数(吨)"></el-table-column>
      <el-table-column prop="percentage" min-width="120"  label="比例">
          <template scope="scope">
            {{scope.row.percentage?scope.row.percentage:'-'}}
          </template>
      </el-table-column>
    </el-table> -->

     <table class="table" >
       <tr>
          <td rowspan="2" style="min-width:200px;font-weight:bold;font-size:22px">日期</td>
          <td v-for="item in tableList" :key="item.month" colspan="4" style="font-weight: bold;font-size:22px">{{item.month}}</td>
       </tr>
          <tr>
          <template v-for="item in tableList" >
              <td style="font-weight: bold;font-size:20px" >国五</td>
              <td style="font-weight: bold;font-size:20px" >国六</td>
              <td style="font-weight: bold;font-size:20px" >电动</td>
              <td style="font-weight: bold;font-size:20px" >总计</td>
          </template>
        </tr>
       <tr>
        <td style="font-weight: bold;font-size:20px">车次</td>
        <template v-for="item in tableList" >
            <td >{{item.vhcNoSum.idG5}}</td>
            <td >{{item.vhcNoSum.idG6}}</td>
            <td >{{item.vhcNoSum.idD}}</td>
            <td >{{item.vhcNoSum.idSum}}</td>
          </template>
       </tr>
        <tr>
        <td style="font-weight: bold;font-size:20px">吨数(吨)</td>
        <template v-for="item in tableList" >
            <td >{{item.weightSum.idG5}}</td>
            <td >{{item.weightSum.idG6}}</td>
            <td >{{item.weightSum.idD}}</td>
            <td >{{item.weightSum.idSum}}</td>
          </template>
       </tr>
        <tr>
        <td style="font-weight: bold;font-size:20px">吨数占比</td>
        <template v-for="item in tableList" >
            <td >{{item.unitRatios.idG5}}</td>
            <td >{{item.unitRatios.idG6}}</td>
            <td >{{item.unitRatios.idD}}</td>
            <td >{{item.unitRatios.idSum}}</td>
          </template>
       </tr>
    </table>
  </div>
    <div style="height:45vh">
          <el-row :gutter="20" style="margin:0 0 ">
          <el-col :span="12">
            <div class="left_two" >
               <div class="left_h">
                  <span class="span_one">车次对比</span>
              </div>
              <div id="zhu"   style="height:41vh"></div>
            </div>
          </el-col>

          <el-col :span="12">
            <div class="left_two" >
               <div class="left_h">
                  <span class="span_one">吨数对比</span>
              </div>
              <div id="zhu1"  style="height:41vh"></div>
            </div>
          </el-col>
        </el-row>
      </div>

   <!-- <div class="whole">
    <div class="top">
        <div  class="title">
          <h4 >车次对比</h4>
        </div>
        <div class="whole1" id="zhu"></div>
    </div>
    <div class="bot">
        <div  class="title">
          <h4 >吨数对比</h4>
        </div>
        <div class="whole1" id="zhu1"></div>
    </div>
  </div> -->

  <!-- <div class="bottom" v-if="tableList.length>0">
    <div class="left_one" >
      <div class="left_h">
        <span class="span_one">{{tableList[0].months}}&nbsp;车次对比</span>
      </div>
       <div id="pie1" style="width:100%; height: 38vh;"></div>
    </div>
     <div class="left_one" >
      <div class="left_h">
        <span class="span_one">{{tableList[7].months}}&nbsp;车次对比</span>
      </div>
       <div id="pie2" style="width:100%; height: 38vh;"></div>
    </div>
     <div class="left_one" >
      <div class="left_h">
        <span class="span_one">{{tableList[0].months}}&nbsp;吨数对比</span>
      </div>
       <div id="pie3" style="width:100%; height: 38vh;"></div>
    </div>
     <div class="left_one" >
      <div class="left_h">
        <span class="span_one">{{tableList[7].months}}&nbsp;吨数对比</span>
      </div>
       <div id="pie4" style="width:100%; height: 38vh;"></div>
    </div>

  </div> -->
     <!-- <el-form :inline="true"  class="demo-form-inline" label-width="90px" size="mini" >
         <div class="searchBox inpBox">
            <div>
              <el-form-item label="日期:" prop="enterTimes">
                <el-date-picker
                  style="width:310px"
                  v-model="searchFrom.enterTimes"
                   value-format="yyyy-MM"
                  type="monthrange"
                  range-separator="至"
                  start-placeholder="开始月份"
                  end-placeholder="结束月份"
                  @change="enterTimesFn"
                ></el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="searchFn">查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary"  @click="resetForm()">重置</el-button>
              </el-form-item>
            </div>
        </div>
      </el-form> -->
      <!-- <div class="title">
        <h4>拉运统计</h4>
      </div>
      <div class="cont">
        <div class="left">
        <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"
             height="100%" style="width: 100%" center border>
          <el-table-column prop="year" label="排放阶段" width="150" align="center">
              <el-table-column prop="year" label="日期" align="center" width="150"></el-table-column>
          </el-table-column>
           <el-table-column property="reportDescribe" min-width="120"  :show-overflow-tooltip="true" label="电动"></el-table-column>
          <el-table-column property="reportDescribe" min-width="120"  :show-overflow-tooltip="true" label="国6"></el-table-column>
          <el-table-column prop="vhcRegistCode"  min-width="120" :show-overflow-tooltip="true" label="国5"></el-table-column>
          <el-table-column prop="registDate" min-width="120"  label="国4"></el-table-column>
          <el-table-column prop="standardsName"  min-width="120"  :show-overflow-tooltip="true" label="其他"></el-table-column>
        </el-table>
        </div>
        <div class="right" id="pie1"></div>
      </div> -->
       <!-- <div class="title">
        <h4>车辆通行统计</h4>
      </div>
      <div class="cont">
        <div class="left">
        <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"
             height="100%" style="width: 100%" center border>
          <el-table-column prop="year" label="排放阶段" width="150" align="center">
              <el-table-column prop="year" label="日期" align="center" width="150"></el-table-column>
          </el-table-column>
           <el-table-column property="reportDescribe" min-width="120"  :show-overflow-tooltip="true" label="电动"></el-table-column>
          <el-table-column property="reportDescribe" min-width="120"  :show-overflow-tooltip="true" label="国6"></el-table-column>
          <el-table-column prop="vhcRegistCode"  min-width="120" :show-overflow-tooltip="true" label="国5"></el-table-column>
          <el-table-column prop="registDate" min-width="120"  label="国4"></el-table-column>
          <el-table-column prop="standardsName"  min-width="120"  :show-overflow-tooltip="true" label="其他"></el-table-column>
        </el-table>
        </div>
        <div class="right" id="pie1"></div>
      </div> -->
 </div>
</template>

<script>
import {
  // driverStandingBookList
  monthlyStatisticsList } from '@/api/vgs-driver'
export default {
  data () {
    return {
      searchFrom: {},
      tableList: [],
      loading: false
    }
  },
  created () {
    // monthlyStatisticsList().then(res => {
    //   this.tableList = res
    // })
    this.getList()
  },
  mounted () {
    // this.searchFn()
    this.zhuFn()
    this.zhuFn1()
  },
  methods: {
    getList () {
      this.loading = true
      monthlyStatisticsList({ }).then(res => {
        this.loading = false
        this.tableList = res
        // 解决表格固定列错位
        // setTimeout(() => {
        //   this.$nextTick(() => {
        //     console.log(this.$refs)
        //     this.$refs.table.doLayout()
        //   })
        // }, 300)
      })
    },
    zhuFn (searchFrom) {
      monthlyStatisticsList(this.searchFrom).then(res => {
        let guofive = []
        let guosix = []
        let ele = []
        let total = []
        let valueArr = []

        res.forEach((item, index) => {
          guofive.push(item.vhcNoSum.idG5)
          guosix.push(item.vhcNoSum.idG6)
          ele.push(item.vhcNoSum.idD)
          total.push(item.vhcNoSum.idSum)
          valueArr.push(item.month)
        })
        let myChart = this.$echarts.init(document.getElementById('zhu'))
        let option = {
          color: ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de'],
          grid: {
            left: '5%',
            right: '5%',
            bottom: '9%',
            top: '10%',
            containLabel: true
          },
          tooltip: {
            trigger: 'axis',
            formatter: function (params) {
              var relVal = params[0].name
              for (var i = 0, l = params.length; i < l; i++) {
                relVal += '<br/>' + params[i].marker + params[i].seriesName + ': ' + params[i].value + ' 次'
              }
              return relVal
            }
          },
          legend: {
            data: ['国5', '国6', '电动', '总计'],
            color: ['#fff'],
            textStyle: {
              color: '#fff'
            }
          },
          xAxis: {
            // name: '日期',
            type: 'category',
            // 横坐标轴颜色
            axisLine: {
              lineStyle: {
                color: '#14D5FF'
              }
            },
            data: valueArr,
            axisLabel: {
              interval: 0,
              rotate: 20,
              textStyle: {
                fontFamily: 'Microsoft YaHei'
              }
            }
          },
          yAxis: {
            name: '单位：次',
            type: 'value',
            axisLine: {
              lineStyle: {
                color: '#14D5FF'
              }
            },
            splitLine: {
              lineStyle: {
                color: '#14D5FF'
              }
            }
          },
          series: [
            {
              name: '国5',
              type: 'bar',
              data: guofive
            },
            {
              name: '国6',
              type: 'bar',
              data: guosix
            },
            {
              name: '电动',
              type: 'bar',
              data: ele
            },
            {
              name: '总计',
              type: 'bar',
              data: total
            }
          ]
        }
        option && myChart.setOption(option)
      })
    },
    zhuFn1 (searchFrom) {
      monthlyStatisticsList(this.searchFrom).then(res => {
        let guofive = []
        let guosix = []
        let ele = []
        let total = []
        let valueArr = []
        res.forEach((item, index) => {
          guofive.push(item.weightSum.idG5)
          guosix.push(item.weightSum.idG6)
          ele.push(item.weightSum.idD)
          total.push(item.weightSum.idSum)
          valueArr.push(item.month)
        })
        let myChart = this.$echarts.init(document.getElementById('zhu1'))
        let option = {
          color: ['#00CCFF', '#00CC66', '#fc8452', '#ea7ccc'],
          grid: {
            left: '5%',
            right: '5%',
            bottom: '9%',
            top: '10%',
            containLabel: true
          },
          tooltip: {
            trigger: 'axis',
            formatter: function (params) {
              var relVal = params[0].name
              for (var i = 0, l = params.length; i < l; i++) {
                relVal += '<br/>' + params[i].marker + params[i].seriesName + ': ' + params[i].value + ' 吨'
              }
              return relVal
            }
          },
          legend: {
            data: ['国5', '国6', '电动', '总计'],
            color: ['#fff'],
            textStyle: {
              color: '#fff'
            }
          },
          xAxis: {
            // name: '日期',
            type: 'category',
            // 横坐标轴颜色
            axisLine: {
              lineStyle: {
                color: '#14D5FF'
              }
            },
            data: valueArr,
            axisLabel: {
              interval: 0,
              rotate: 20,
              textStyle: {
                fontFamily: 'Microsoft YaHei'
              }
            }
          },
          yAxis: {
            name: '单位：吨',
            type: 'value',
            axisLine: {
              lineStyle: {
                color: '#14D5FF'
              }
            },
            splitLine: {
              lineStyle: {
                color: '#14D5FF'
              }
            }
          },
          series: [
            {
              name: '国5',
              type: 'bar',
              data: guofive
            },
            {
              name: '国6',
              type: 'bar',
              data: guosix
            },
            {
              name: '电动',
              type: 'bar',
              data: ele
            },
            {
              name: '总计',
              type: 'bar',
              data: total
            }
          ]
        }
        option && myChart.setOption(option)
      })
    }
    //   searchFn () {
    //     const loading = this.$loading({
    //       lock: true,
    //       text: '正在处理...'
    //     })
    //     driverStandingBookList(this.searchFrom).then(res => {
    //       loading.close()
    //       this.tableList = res
    //       let arr1 = []
    //       let arr2 = []
    //       let arr3 = []
    //       let arr4 = []
    //       res.forEach((item, index) => {
    //         if (index < 3) {
    //           arr1.push({ sName: item.sName, value: item.vNo ? item.vNo : 0 })
    //           arr3.push({ sName: item.sName, value: item.tWeight ? item.tWeight : 0 })
    //         }
    //         if (index < 7 && index > 3) {
    //           arr2.push({ sName: item.sName, value: item.vNo ? item.vNo : 0 })
    //           arr4.push({ sName: item.sName, value: item.tWeight ? item.tWeight : 0 })
    //         }
    //       })
    //       // 解决表格固定列错位
    //       setTimeout(() => {
    //         this.$nextTick(() => {
    //           this.$refs.table.doLayout()
    //           this.pie(arr1, res[0].months, 'pie1')
    //           this.pie(arr2, res[7].months, 'pie2')
    //           this.pie(arr3, res[0].months, 'pie3')
    //           this.pie(arr4, res[7].months, 'pie4')
    //         })
    //       }, 300)
    //     })
    //   },
    //   pie (data, name, id) {
    //     let w = document.documentElement.clientWidth
    //     let num = w > 2000 ? 240 : 150
    //     let fontNum = w > 2000 ? 26 : 20
    //     console.log(num)
    //     let _this = this
    //     var img = 'data:image/png;base64,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'
    //     let idChart = _this.$echarts.init(document.getElementById(id))
    //     var dataArr = []
    //     var color = ['#00cfff', '#ffe000', '#ffa800', '#ff5b00', '#ff3000', '#00ffff', '#006ced']
    //     for (var i = 0; i < data.length; i++) {
    //       dataArr.push({
    //         value: data[i].value,
    //         name: data[i].sName,
    //         itemStyle: {
    //           normal: {
    //             borderWidth: 5,
    //             shadowBlur: 20,
    //             borderColor: color[i],
    //             shadowColor: color[i]
    //           }
    //         }
    //       }, {
    //         value: 1,
    //         name: '',
    //         itemStyle: {
    //           normal: {
    //             label: {
    //               show: false
    //             },
    //             labelLine: {
    //               show: false
    //             },
    //             color: 'rgba(0, 0, 0, 0)',
    //             borderColor: 'rgba(0, 0, 0, 0)',
    //             borderWidth: 0
    //           }
    //         }
    //       })
    //     }
    //     var seriesOption = [{
    //       name: '',
    //       type: 'pie',
    //       clockWise: false,
    //       radius: [num / 2, num / 2 + 20],
    //       hoverAnimation: false,
    //       itemStyle: {
    //         normal: {
    //           label: {
    //             show: true,
    //             position: 'outside',
    //             color: '#ddd',
    //             fontSize: fontNum,
    //             formatter: function (params) {
    //               if (params.name) {
    //                 return params.name + '：' + params.value
    //               }
    //             }
    //           }
    //         }
    //       },
    //       data: dataArr
    //     }]
    //     var option = {
    //       backgroundColor: 'rgba(225,225,225,0)',
    //       color: color,
    //       title: {
    //         text: name,
    //         top: '48%',
    //         textAlign: 'center',
    //         left: '49%',
    //         textStyle: {
    //           color: '#fff',
    //           fontSize: fontNum,
    //           fontWeight: '400'
    //         }
    //       },
    //       graphic: {
    //         elements: [{
    //           type: 'image',
    //           z: 3,
    //           style: {
    //             image: img,
    //             width: num,
    //             height: num
    //           },
    //           left: 'center',
    //           top: 'center',
    //           position: [100, 100]
    //         }]
    //       },
    //       tooltip: {
    //         trigger: 'item',
    //         backgroundColor: 'rgba(0,0,0,0.5)',
    //         formatter: function (params) {
    //           var percent = 0
    //           var total = 0
    //           for (var i = 0; i < data.length; i++) {
    //             total += data[i].value
    //           }
    //           if (total == 0) {
    //             percent = 0
    //           } else {
    //             percent = ((params.value / total) * 100).toFixed(0)
    //           }

    //           return params.marker + '<span style="color:' + params.color + '">' + params.data['name'] + '\n' + params.data['value'] + '</span></br>' + '占百分比：' + percent + '%'
    //         }
    //       },
    //       legend: {
    //         show: false
    //       },
    //       toolbox: {
    //         show: false
    //       },
    //       series: seriesOption
    //     }
    //     idChart.setOption(option)
    //   },
    //   objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
    //     if (columnIndex === 0) {
    //       if (rowIndex === 0 || rowIndex === 4) {
    //         return {
    //           rowspan: 4,
    //           colspan: 1
    //         }
    //       } else {
    //         return {
    //           rowspan: 0,
    //           colspan: 0
    //         }
    //       }
    //     }
    //   },

    //   enterTimesFn (e) {
    //     let year1 = e[0].split('-')[0]
    //     let mon1 = e[0].split('-')[1]
    //     let year2 = e[1].split('-')[0]
    //     let mon2 = e[1].split('-')[1]
    //     if (year2 - year1 > 2) {
    //       this.$alert('时间范围不能大于24个月', '系统提示')
    //       this.$set(this.searchFrom, 'enterTimes', null)
    //     } else if (year2 - year1 == 2) {
    //       if ((Math.abs(Number(mon1) - 12)) + Number(mon2) > 11) {
    //         this.$alert('时间范围不能大于24个月', '系统提示')
    //         this.$set(this.searchFrom, 'enterTimes', null)
    //       }
    //     }
    //   },
    //   nowYear (date) {
    //     let nowDate = new Date()
    //     let array = []
    //     let year = nowDate.getFullYear()
    //     let mon = nowDate.getMonth() + 1
    //     array[1] = year + '-' + (mon < 10 ? '0' + mon : mon)
    //     let startMon = mon - 11
    //     let statryear = ''
    //     if (startMon <= 0) {
    //       startMon = startMon + 12
    //       statryear = year - 1
    //     } else {
    //       statryear = year
    //     }
    //     array[0] = statryear + '-' + (startMon < 10 ? '0' + startMon : startMon)
    //     return array
    //   },
    //   resetForm () {
    //     this.searchFrom = {}
    //   },
    //   emptyFn (row, column, cellValue) {
    //     return cellValue || 0
    //   }

  }
}
</script>

<style scoped lang='less'>
.cont{
  height: calc(100% + 80px);
  background: url('../../../assets/dapingImg/bg.png') 100%;

  .table{
  color: #fff;
  border: 1px solid #fff;
  border-collapse: collapse;
  // table-layout: fixed;
  text-align: center;
  width: 100%;
  tr,td{
     border: 1px solid #fff;
  }
  td {
      word-wrap: break;
      // width: auto !important;
      padding: 20px;
      white-space: nowrap;
      font-weight: bold;
      font-size: 18px;
  }
}
}
::v-deep  .el-table{
  background: none!important;
  font-size: 22px;
}

::v-deep .el-table th, ::v-deep .el-table tr {
     color: #fff;
     background: none!important;
}
::v-deep.el-table td{
  padding: 12px 0 !important;
}
::v-deep .el-table thead{
  background: url("../../../assets/dapingImg/mk-title-bg.png") no-repeat;
}
.bottom{
  height: calc(100% - 500px);
  display: flex;
  justify-content: space-around;
}
.left_one {
  //轮播
  padding: 0px 0px 0px 1px;
  box-sizing: border-box;
  height: 40vh;
  margin-bottom: 10px;
  width:24%;
  background: url("../../../assets/dapingImg/bg1.png") no-repeat;
  background-size: 100% 100%;

  // overflow-x: scroll;
}
.left_h {
  // height: 50px;
  // line-height: 50px;
  // color: #03faec;
  // // font-weight: 700;
  // font-size: 22px;
  // background: url("../../../assets/dapingImg/mk-title-bg.png") no-repeat;
  // background-size: 100% 100%;

  height: 30px;
  line-height: 30px;
  color: #03faec;
  font-size: 20px;
  background: rgba(41, 139, 208, 0.3);
  box-shadow: -8px 16px 62px -18px rgba(18,102,210,0.75);
  margin-bottom: 20px;
  .span_one {
    float: left;
    margin-left: 10px;
    font-size: 26px;
  }
  // .span_two {
  //   float: right;
  //   margin: 5px;
  //   font-size: 16px;

  //   font-weight: normal;order-bottom
  // }
}
  //表头画斜线
  ::v-deep .el-table thead.is-group th {
        background: none;
        padding: 0px!important;
    }
  ::v-deep .el-table thead.is-group tr:nth-child(even){
          background: none;
          padding: 0px;
  }
    // ::v-deep .el-table thead.is-group tr:first-of-type th:first-of-type {
    //     border-bottom: none;/*中间的横线去掉*/
    // }

    // ::v-deep .el-table thead.is-group tr:first-of-type th:first-of-type div.cell {
    //     text-align: right;/*上边文字靠右*/
    // }

    // ::v-deep .el-table thead.is-group tr:last-of-type th:first-of-type div.cell {
    //     text-align: left;/*下边文字靠左*/
    // }

    /*核心代码*/
    ::v-deep .el-table thead.is-group tr:first-of-type th:first-of-type:before {
        content: "";
        position: absolute;
        width: 1px;
        height: 120px;/*斜线的长度*/
        top: 0;
        left: 0;
        background-color: grey;
        opacity: 0.2;
        display: block;
        transform: rotate(-67deg);/*调整斜线的角度*/
        -webkit-transform-origin: top;
        transform-origin: top;
    }

    ::v-deep .el-table thead.is-group tr:last-of-type th:first-of-type:before {
        content: "";
        position: absolute;
        width: 1px;
        height: 120px;/*斜线的长度*/
        bottom: 0;
        right: 0;
        background-color: grey;
        opacity: 0.2;
        display: block;
        transform: rotate(-67deg);/*调整斜线的角度*/
        -webkit-transform-origin: bottom;
        transform-origin: bottom;
    }
    ::v-deep .el-table thead.is-group th{
        height: 27.4px;
    }

.whole {
  width: 100%;
  height: 1200px;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  .top {
    width: 100%;
    height: 50%;
  }
  .bot {
    width: 100%;
    height: 50%;
  }
}
.whole1 {
  height:calc(100% - 40px);
}
.title {
   color: #03faec;
   font-size: 26px;
}

.left_two {
  padding: 0px 0px 0px 1px;
  box-sizing: border-box;
  height: 44vh;
  overflow: hidden;
  width: 100%;
  background: url("../../../assets/dapingImg/bg1.png") no-repeat;
  background-size: 100% 100%;
  // overflow-x: scroll;
}
// @media screen and (min-width:768px) and (max-width:1024px){
//   td {
//       padding: 25px 30px;
//       white-space:nowrap;
//       font-weight: bold;
//       font-size: 18px;
//   }
// }
// @media screen and (min-width:1024px){
//   td {
//       padding: 25px 30px;
//       white-space:nowrap;
//       font-weight: bold;
//       font-size: 18px;
//   }
// }

</style>
